const subscribers = new Set();

function subscribe(callback) {
    if (typeof callback !== 'function') {
        throw Error('Callback must be a function');
    }

    subscribers.add(callback);
}

function logEvent(eventType, eventProperties) {
    subscribers.forEach(callback => {
        callback(eventType, eventProperties);
    });
}

export {
    subscribe,
    logEvent
};
